<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      d="M10.4072 4.9043C11.2648 3.56655 13.2272 3.58914 14.0537 4.94629L21.2002 16.6816C22.0727 18.1144 21.0417 19.9502 19.3643 19.9502H4.69434C2.99475 19.95 1.96752 18.0706 2.88477 16.6396L10.4072 4.9043Z"
      stroke="currentColor"
      stroke-width="1.9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0008 8.5498C12.5252 8.5498 12.9508 8.97514 12.9508 9.4998V13.2998C12.9508 13.8245 12.5252 14.2498 12.0008 14.2498C11.4764 14.2498 11.0508 13.8245 11.0508 13.2998V9.4998C11.0508 8.97514 11.4764 8.5498 12.0008 8.5498Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9961 15.2002C11.4743 15.2002 11.0508 15.6255 11.0508 16.1502C11.0508 16.6749 11.4743 17.1002 11.9961 17.1002H12.0055C12.5273 17.1002 12.9508 16.6749 12.9508 16.1502C12.9508 15.6255 12.5273 15.2002 12.0055 15.2002H11.9961Z"
      fill="currentColor"
    />
  </PathSlot>
</template>

<script lang="ts" setup>
import iconPropsType from './iconPropsType';
import PathSlot from './PathSlot.vue';

const props = defineProps(iconPropsType);
</script>
